<template>
  <div class="mt-4">
    <v-card class='citation__text' tile v-for='lang in usingLanguagesForCitation()'>
      <v-tooltip right color='white'>
        <template v-slot:activator='{ on, attrs }'>
          <v-btn v-bind='attrs' v-on='on' icon @click='copyTextCitation(barcode, id, lang)'>
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
        </template>
        <span class='color-secondary font-weight-bold'>Скопировать для цитирования</span>
      </v-tooltip>
      {{ getTextOfExhibitCitationByLanguage(barcode, id, lang) }}
    </v-card>
  </div>
</template>

<script>

import {
  getTextOfExhibitCitationByLanguage,
  usingLanguagesForCitationExhibit,
} from '@/services/citationExhibitService';

export default {
  name: "CitationTab",

  props: {
    id: {
      type: String,
      require: true,
    },
    barcode: {
      type: String,
      require: true,
    },
  },

  methods: {
    getTextOfExhibitCitationByLanguage,
    usingLanguagesForCitation() {
      return usingLanguagesForCitationExhibit;
    },
    copyTextCitation(barcode, id, lang = 'RU') {
      try {
        navigator.clipboard.writeText(this.getTextOfExhibitCitationByLanguage(barcode, id, lang));
      } catch (e) {
        throw e;
      }
    },
  },

}
</script>